import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-12">
          <h4 className="text-2xl md:text-3xl font-bold mb-6">株式会社ON TRUST</h4>
          <a
            href="https://on-trust.co.jp/about_us"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors text-lg font-medium cursor-pointer"
          >
            https://on-trust.co.jp/about_us
            <i className="ri-external-link-line"></i>
          </a>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex items-center justify-center gap-6 mb-4">
            <Link
              to="/privacy-policy"
              className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
            >
              プライバシーポリシー
            </Link>
          </div>
          <p className="text-gray-400 text-base">
            © 2024 株式会社ON TRUST. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
